<template id="LeitorQrCode">
    <v-ons-page id="LeitorQrCodePage">
        <img src="../assets/img/logo.png" width="200px" style="margin:20px; padding-top:20px">
        <h3 class="textoCPF book">Aponte a camera do seu celular <br> para o qrcode da máquina e<br> aguarde liberar.</h3>

        <section> 
            <qrcode-stream @decode="onDecode"></qrcode-stream>
        </section>
        <section>
          
        </section>
    </v-ons-page>
</template>
<script>
export default {
  name: 'LeitorQrCode',
  key: 'LeitorQrCode',

  props: ['pageStack'],
  methods: {
    onDecode (decodedString) {
      if ((decodedString != null) && ( decodedString != "")) {
        //alert(decodedString); 
        //var arrUrl = decodedString.split("/")
        this.$socket.emit('join',{ "room": '6',
                          "dsNome": localStorage.getItem("dsNome"),
                          "idUser": parseInt(localStorage.getItem("idCliente"))});
      }
    },
    back () { 
        this.$emit('pop');
    }
  },
  sockets: { 

  }
}
</script>